import { BankDetailsFormModel_MX } from './formModel';

export const getInitialValues = (): BankDetailsFormModel_MX => {
  return {
    iban: '',
    bankAccountHolder: '',
    preferredPaymentDay: '',
  };
};
